var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0819 17.8987C13.4615 18.319 12.681 18.6692 11.7304 18.9794L10.1495 19.4997C6.17713 20.7804 4.08587 19.7098 2.79509 15.7374L1.51432 11.785C0.233551 7.81264 1.29419 5.71137 5.26658 4.4306L6.84754 3.91028C7.25778 3.78021 7.64802 3.67014 8.01824 3.6001C7.71806 4.21047 7.47791 4.95091 7.27779 5.80142L6.2972 9.99395C5.31661 14.1765 6.60739 16.2377 10.7799 17.2283L12.4609 17.6285C13.0412 17.7686 13.5816 17.8587 14.0819 17.8987Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6611 7.03223L16.5141 8.26297",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6797 10.9043L13.5814 11.6447",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9852 3.60011C21.0659 4.80083 21.256 6.52187 20.6857 8.94332L19.7051 13.1258C18.8646 16.738 17.2036 18.1989 14.0817 17.8987C13.5814 17.8587 13.0411 17.7686 12.4607 17.6286L10.7797 17.2283C6.60716 16.2377 5.31638 14.1765 6.29697 9.99395L7.27756 5.80144C7.47768 4.95092 7.71783 4.21048 8.01801 3.60011C9.18873 1.17865 11.1799 0.528259 14.5219 1.31874L16.193 1.70897",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.3eea64a3eecb05570cb6c954fdd1b2d6.svg";
export { ForwardRef as ReactComponent };